<template>
    <div v-if="otherPosts.length >= 2" class="posts-box has-cat cat-sports has-load-more"
        v-bind:class="{ 'u-margin-t-40': this.hasMargin }">
        <div class="posts-box__top" v-bind:style="{ borderLeft: '3px solid ' + borderColor }">
            <h4 class="posts-box__top__title"> {{ categoryName }}</h4>
            <!-- <div class="posts-box__category">
                                    <div class="flex-menu-parent">
                                        <ul class="menu flex">
                                            <li class="active"><a href="#">Sports</a></li>
                                            <li><a href="#">World</a></li>
                                            <li><a href="#">Entertainment</a></li>
                                            <li><a href="#">Technology</a></li>
                                        </ul>
                                    </div>
                                </div> -->
        </div>
        <div class="dual-col-posts">

            <div class="posts-list has-big-in-top">

                <article v-for="post in topPosts.slice(0, 1)" :key="'topPost_' + post.postID + post.categoryCode"
                    class="post-item">
                    <figure>
                        <router-link
                            :to="{ name: 'read', params: { category: post.categoryCode, slug: post.searchCode, id: post.postID } }"><img
                                v-lazy="post.absoluteThumbUrl" v-bind:alt="post.title"></router-link>
                    </figure>
                    <div class="post-content">
                        <h4 class="post-title"><router-link
                                :to="{ name: 'read', params: { category: post.categoryCode, slug: post.searchCode, id: post.postID } }">{{
                                    getBigPostTitle(post) }}</router-link></h4>
                        <div class="post-meta">
                            <time><i class="fa fa-clock-o"></i>{{ post.postDate | timeAgo }} </time>
                        </div>
                    </div>
                </article>

                <article v-for="post in otherPosts.slice(0, 3)" :key="'otherPost_' + post.postID + post.categoryCode"
                    class="post-item">
                    <figure>
                        <router-link
                            :to="{ name: 'read', params: { category: post.categoryCode, slug: post.searchCode, id: post.postID } }"><img
                                v-lazy="post.absoluteThumbUrl" v-bind:alt="post.title"></router-link>
                    </figure>
                    <div class="post-content">
                        <h4 class="post-title"><router-link
                                :to="{ name: 'read', params: { category: post.categoryCode, slug: post.searchCode, id: post.postID } }">{{
                                    getSmallPostTitle(post) }}</router-link></h4>
                        <div class="post-meta">
                            <time><i class="fa fa-clock-o"></i>{{ post.postDate | timeAgo }}</time>
                        </div>
                    </div>
                </article>
            </div><!--//.posts-list -->

            <div class="posts-list has-big-in-top">

                <article v-for="post in topPosts.slice(1)" :key="'topPost_' + post.postID + post.categoryCode"
                    class="post-item">
                    <figure>
                        <router-link
                            :to="{ name: 'read', params: { category: post.categoryCode, slug: post.searchCode, id: post.postID } }"><img
                                v-lazy="post.absoluteThumbUrl" v-bind:alt="post.title"></router-link>
                    </figure>
                    <div class="post-content">
                        <h4 class="post-title"><router-link
                                :to="{ name: 'read', params: { category: post.categoryCode, slug: post.searchCode, id: post.postID } }">{{
                                    getBigPostTitle(post) }}</router-link></h4>
                        <div class="post-meta">
                            <time><i class="fa fa-clock-o"></i>{{ post.postDate | timeAgo }} </time>
                        </div>
                    </div>
                </article>

                <article v-for="post in otherPosts.slice(3)" :key="'otherPost_' + post.postID + post.categoryCode"
                    class="post-item">
                    <figure>
                        <router-link
                            :to="{ name: 'read', params: { category: post.categoryCode, slug: post.searchCode, id: post.postID } }"><img
                                v-lazy="post.absoluteThumbUrl" v-bind:alt="post.title"></router-link>
                    </figure>
                    <div class="post-content">
                        <h4 class="post-title"><router-link
                                :to="{ name: 'read', params: { category: post.categoryCode, slug: post.searchCode, id: post.postID } }">{{
                                    getSmallPostTitle(post) }}</router-link></h4>
                        <div class="post-meta">
                            <time><i class="fa fa-clock-o"></i>{{ post.postDate | timeAgo }}</time>
                        </div>
                    </div>
                </article>
            </div>
        </div>
        <div class="posts-box__bottom">
        </div>
        <!-- <script type="application/javascript">
                                var
                                mpn_wi={userId:12527,siteId:101900,widgetId:103807,widgetType:0};if(void
                                0===mpn_ref)var mpn_ref=[mpn_wi];else mpn_ref.push(mpn_wi);var
                                mpn_sid=document.getElementById('monadplugscript');if(!mpn_sid){var
                                mpn_dt=new
                                Date,mpn_ns=document.createElement('script');mpn_ns.id='monadplugscript',mpn_ns.type='text/javascript',mpn_ns.defer=!0,mpn_ns.src='//cdn.monadplug.com/format/native/js/hood.js?v='+mpn_dt.getYear()+mpn_dt.getMonth()+mpn_dt.getUTCDate()+mpn_dt.getUTCHours();var
                                pmn_os=document.getElementsByTagName('script')[0];pmn_os.parentNode.insertBefore(mpn_ns,pmn_os)}
                                </script>
                                <div id='12527-101900-103807'></div>  -->
        <div v-if="adWebPage != null" class="ad-728-90-category-below">
            <a v-bind:href="adWebPage" target="_blank">
                <img v-bind:src="adPhotoUrl">
            </a>
        </div>
        <div v-else class="ad-728-90-category-below">
            <GoogleAdSense :adSlot="'6152021407'" :width="728" :height="90" />
        </div>
    </div>
</template>

<script>
import { NewsService } from '../common/api.service'
import GoogleAdSense from "../components/GoogleAdSense.vue";

export default {
    name: "CategoryBox",
    components: { GoogleAdSense },
    props: ['categoryID', 'categoryName', 'hasMargin', 'borderColor', 'adWebPage', 'adPhotoUrl'],
    data() {
        return {
            topPosts: [],
            otherPosts: []
        }
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData: function () {
            NewsService.getPostsMain(8, true, this.categoryID)
                .then(res => {
                    this.topPosts = res.data.slice(0, 2);
                    this.otherPosts = res.data.slice(2);
                });
        },
        getBigPostTitle(post) {
            if (post.title.length < 67)
                return post.title;
            else if (post.shortTitle) {
                if (post.shortTitle.length < 67)
                    return post.shortTitle;
                else
                    return post.shortTitle.slice(0, 63) + "...";
            }
            else
                return post.title.slice(0, 63) + "...";
        },
        getSmallPostTitle(post) {
            if (post.title.length < 62)
                return post.title;
            else if (post.shortTitle) {
                if (post.shortTitle.length < 62)
                    return post.shortTitle;
                else
                    return post.shortTitle.slice(0, 58) + "...";
            }
            else
                return post.title.slice(0, 58) + "...";
        }
    }
}
</script>

<style scoped>   .posts-list.has-big-in-top .post-item:first-child {
       height: 355px;
   }

   .posts-list.has-big-in-top .post-item:first-child img {
       object-fit: cover;
       width: 100%;
       height: 220px;
   }

   .posts-list.has-big-in-top .post-item:nth-last-child(-n+3) {
       height: 70px;
   }

   .ad-728-90-category-below {
       text-align: center;
       margin-top: 20px;
       height: 100px;
   }
</style>



// WEBPACK FOOTER //
// src/components/CategoryBox.vue